import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useCreateConversation from '../../../../../../hooks/conversations/useCreateConversation';
import useSaveTalent from '../../../../../../hooks/talents/useSaveTalent';
import useCheckConversation from '../../../../../../hooks/conversations/useCheckConversation';
import './searchTalentCard.css';
import { starIcon, scheduleIcon, userChefIcon, timerIcon } from '../../../../../../utils/icons';
import useSignedImage from '../../../../../../hooks/useSignedImage';

const SearchTalentCard = ({ id, data, employeeId, onDeleteSuccess }) => {
    const { createConversation, isLoading: conversationLoading, error: conversationError } = useCreateConversation();
    const { saveTalent, checkTalentExistence, isLoading, error, talentExist } = useSaveTalent();
    const { checkConversationExistence, conversationExists, conversation } = useCheckConversation();
    const navigate = useNavigate();
    const { name, position, available, schedule, profileImageUrl } = data
    const { imageUrl: signedEmployeeImageUrl } = useSignedImage(profileImageUrl, '/default-employee.png');

    useEffect(() => {
        checkConversationExistence(employeeId, 'talent');
    }, [ checkConversationExistence]);

    useEffect(()=> {
      checkTalentExistence(employeeId)
    }, [])

    const handleConversationInitiation = async () => {
        if (!conversationLoading) {
            try {
                const newConversation = await createConversation(employeeId, null, 'talent');
              
                if (newConversation) {
                    navigate(`/panel-empresa/inbox-empresa/${newConversation.id}/${employeeId}`);
                }
            } catch (error) {
                console.error('Error initiating conversation:', error);
            }
        }
    };

    const handleSaveTalent = async () => {
        if (!isLoading) {
            try {
                await saveTalent(employeeId);
            } catch (error) {
                console.error('Error saving talent:', error);
            }
        }
    };

    const renderSaveButton = () => (
        <button
            onClick={handleSaveTalent}
            className="search-talent-card__button"
            disabled={isLoading}
        >
            {isLoading ? 'Guardando...' : 'Guardar'}
        </button>
    );

    const renderContactButton = () => (
        <button
            onClick={handleConversationInitiation}
            className="search-talent-card__button"
            disabled={conversationLoading}
        >
            {conversationLoading ? 'Iniciando...' : 'Contactar'}
        </button>
    );
    
    const renderConversationButton = () => (
        <Link to={`/panel-empresa/inbox-empresa/${conversation.id}/${employeeId}`}>
            <button className="search-talent-card__button">
                Ver Conversación
            </button>
        </Link>
    );

    const renderActionButton = () => {
        if (!talentExist) {
            return renderSaveButton();
        }
        return conversationExists ? renderConversationButton() : renderContactButton();
    };

    return (
        <div className="applicant-item-container">
            <div className="applicant-col-1">
                <img className="search-talent-card__profile-image" src={signedEmployeeImageUrl} alt={name} />
                <div className="applicant-card-info">
                    <h3>{name}</h3>
                </div>
            </div>
            <div className="search-talent-card__col-2-container">
                <div className="search-talent-card__col-2">
                    <div className='search-talent-card__info-container'>
                        <div className="search-talent-card__icon-container">
                            {userChefIcon}
                        </div>
                        <div>
                            <p><strong>Cargo:</strong></p>
                            <p>{position}</p>
                        </div>
                    </div>
                    <div className='search-talent-card__info-container'>
                        <div className="search-talent-card__icon-container">
                            {starIcon}
                        </div>
                        <div>
                            <p><strong>Experiencia:</strong></p>
                            <p>3 años</p>
                        </div>
                    </div>
                </div>
                <div className="search-talent-card__col-2">
                    <div className='search-talent-card__info-container'>
                        <div className="search-talent-card__icon-container">
                            {scheduleIcon}
                        </div>
                        <div>
                            <p><strong>Disponibilidad:</strong></p>
                            <p>{available}</p>
                        </div>
                    </div>
                    <div className='search-talent-card__info-container'>
                        <div className="search-talent-card__icon-container">
                            {timerIcon}
                        </div>
                        <div>
                            <p><strong>Jornada:</strong></p>
                            <p>{schedule}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='search-talent-card__col-3'>
                <div className="search-talent-card__button-container">
                    <Link to={`/empleados/${employeeId}`}>
                        <button className="search-talent-card__button">Perfil</button>
                    </Link>
                
                    {talentExist ? (
                        <button
                            className="search-talent-card__button"
                            disabled={isLoading}
                        >
                            Guardado
                        </button>
                    ) : (
                        <button
                            onClick={handleSaveTalent}
                            className="search-talent-card__button"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Guardando...' : 'Guardar'}
                        </button>
                    )}
   
                    {conversationExists ? (
                        <Link to={`/panel-empresa/inbox-empresa/${conversation.id}/${employeeId}`}>
                            <button className="search-talent-card__button">Ver chat</button>
                        </Link>
                    ) : (
                        <button
                            onClick={handleConversationInitiation}
                            className="search-talent-card__button"
                            disabled={conversationLoading}
                        >
                            {conversationLoading ? 'Iniciando...' : 'Chat'}
                        </button>
                    )}
                   
                </div>
                {error && <p className="error-message">{error.message}</p>}
                {conversationError && <p className="error-message">{conversationError.message}</p>}
            </div>
        </div>
    );
};

export default SearchTalentCard;
